import React, { useContext, useEffect, useRef, useState } from 'react';
import ProfilePicture from './ProfilePicture';
import { professionalInfoSchema } from '../../Validations/User';
import { useFormik } from 'formik';
import axios from 'axios';
import InputElement from '../Element/InputElement';
import { Context } from '../../Context/Context';
import { APPROVELIST, ATTORNEYLIST, LICENSED, UNAPPROVELIST, generateSignedurlApi, isEmailAvailableApi, raiseNotificationApi, updateUserApi, updateUserProfessionalApi } from '../../Constants';
import AttorneyProfilePic from './AttorneyProfilePic';
import { ToastContainer, toast } from 'react-toastify';
import PreferenceFields from './PreferenceFields';
import { validateEmail } from 'Utils';
import { useNavigate } from 'react-router-dom';
import capitalize from 'capitalize';
import { BiError } from 'react-icons/bi';
import FormErrorBanner from '../Element/FormErrorBanner';
import FieldError from '../Element/FieldError';
import { stateUS } from 'states';

function ProfessionalDetailsEdit({setShowEdit, showBack=true}) 
{
  const [showErrorTopMsg, setShowErrorTopMsg] = useState(false);
  const {userDetails, setUserDetails, setUpdateLoggedinData, makeApiCallFunc} = useContext(Context);
  const [states, setStates] = useState(stateUS);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const {legalType} = userDetails; 
  const [attorneyError, setAttorneyError] = useState("");
  const attorneyImageRemoveRef = useRef(null);
  const [isEmailAvailable, setIsEmailAvailable] = useState();
   const [errorMsg, setErrorMsg] = useState({
          case: "",
          state: "",
          profilepic: ""
      });

   
  const [showMoreLabel, setShowMoreLabel] = useState((!legalType || legalType === LICENSED) ? false : true);
 
  const approveData = (values, imgUrl) => {
      const data = {};
      APPROVELIST.map((item) => { 
          if(values[item] !== userDetails[item])
          {
              data[item] = {
                "newValue" : values[item],
                "oldValue" : userDetails[item]
              }
          }
      });
      // if(values.legalType !== LICENSED)
      // {
          ATTORNEYLIST.map((item) => {
            if( values.attorney?.[item] !== userDetails?.attorney?.[item])
            {
              data.attorney = data.attorney ? data.attorney : {};
              return data.attorney = {...data.attorney,
                [item] : {
                  "newValue" : values.attorney?.[item] ? values.attorney?.[item] : "",
                  "oldValue" : userDetails.attorney?.[item] ? userDetails.attorney?.[item] : ''
                }
              }
            }

          })
      // }
      if(userDetails?.profilePic !== imgUrl)
      {
        data.profilePic = {oldValue : userDetails?.profilePic, newValue: imgUrl};
      }
      console.log(data)
      return data;
  }
  const unApproveData = () => {
    const data = {};
    UNAPPROVELIST.map((item) => {
      if(values[item] !== userDetails[item])
      {
        data[item] = values[item];
      }
    });
    data["casePref"] = casePref?.length !== 0 ? casePref  : [];
    data["statePref"] = statePref?.length !== 0 ? statePref  : [];

    return data;
  }
  const checkIfEmailAvailable = (email) => {
    let isAvailable = false;
    makeApiCallFunc(isEmailAvailableApi, {
      email
    },
    ({data}) => {
      isAvailable = data?.available;
      setIsEmailAvailable(isAvailable);
      console.log(data?.available)
    },
    (data) => console.log(data)
    )
  }
  const uploadedProfilePicUrl = async (successCallback) => {
    if(profilePic && profilePic !== userDetails?.profilePic)
    {
      const fileName = new Date().toISOString().replace(/:/g, '-') + userDetails._id;
      const blob = await fetch(profilePic).then((res) => res.blob());
       const imageUrl =  makeApiCallFunc(generateSignedurlApi+fileName,
          {fileType: blob.type},
          async ({data}) => {
            const imguploaded = await fetch(data?.url, {
                method: 'PUT',
                headers: {
                  'Content-Type': blob.type,
                },
                body: blob,
              });
            // The public URL of the uploaded image
            const imageUrl = data?.url.split('?')[0];
            setProfilePic(imageUrl);
            successCallback(imageUrl);
          },
          (data) => { console.log(data) }
        );
    }
    else
    {
      successCallback(profilePic);
    }
  }
  const onSubmit = async(values,action) => {
   await uploadedProfilePicUrl(userUpdation);
  }
  const userUpdation = (imgUrl) => {
    const approvePostData = approveData(values, imgUrl);
    const unApprovePostData = unApproveData(values);
    if(!profilePic)
    {
        window.scrollTo(0, 0);
        setApiError("Please upload your profile picture to proceed")
    }
    
    else if(userDetails?.email !== values.email && !isEmailAvailable )
    {
        window.scrollTo(0, 0);
        setApiError(values.email +" email already associated with another account. Please enter a different email")
    }
    else if(userDetails?.email !== values.email && !validateEmail(values.email))
    {
        window.scrollTo(0, 0);
        setApiError(values.email +" - Please use your work email")
    }
    else if((values.legalType === LICENSED &&(unApprovePostData?.casePref?.length === 0 || unApprovePostData?.statePref?.length === 0)))
    {
      console.log(values)
      window.scrollTo(0, 0);
      unApprovePostData?.casePref?.length === 0  ? setErrorMsg((prev) => { return {...prev, "case" : "Please select atleast one case preference"} }) : setErrorMsg((prev) => { return {...prev, "case" : "" }});
      unApprovePostData?.statePref?.length === 0  ? setErrorMsg((prev) => { return {...prev, "state" : "Please select atleast one state preference"} }) : setErrorMsg((prev) => { return {...prev, "state" : "" }});
      setApiError("You need to choose atleast one preference in each category to proceed")
    }
    else
    {
      if(values.legalType !== LICENSED)
      {
        makeApiCallFunc(
          updateUserApi,
          {...values, "profilePic" : imgUrl, "isUserAssistant": true, user: userDetails._id, verified: false},
          (data) => {
            toast.success("Details updated");
            setTimeout(() => {
              setUpdateLoggedinData(prev => !prev);
              // setShowEdit(false);
              if(!showBack)
                { navigate('/attorney/profile') }
            },1000)
          },
          (data) => console.log(data)
        )
      }
      else
      {
        makeApiCallFunc(
          updateUserProfessionalApi, 
          {
            toBeApproved : Object.entries(approvePostData)?.length ? {...approvePostData, user: userDetails._id, "isUserAssistant": false} : null,
            user: userDetails._id,
            toBeUnapproved : Object.entries(unApprovePostData)?.length ? {...unApprovePostData, user: userDetails._id, "isUserAssistant": false} : null,
          },
          ({data}) => {
              notifyAdmin(data?.user?._id);
              toast.success("Sent the updated information to admin for approval");
              if(!showBack)
                { navigate('/attorney/profile') }
              else
              {
                setUpdateLoggedinData(prev => !prev);

              }
          }
          )
      }
    }
  }
  const notifyAdmin = (userId) => {
      const notificationObj = {
      title : userDetails.verified ? "Account updated" : "Verify the account",
      is_read : false,
      sender: userDetails._id,
      notificationCategory: 0,
      additionalInfo:{
        userId
      },
      type: "1",
      receiver: '0',
      doNotSendEmail: true,
      content: (userDetails.verified ? "Account of " + userDetails.firstName + " " + userDetails.lastName + " has been updated. Please review and approve or deny with a solid feedback" :"A new account has been created that needs admin's verification and approval. Head to the Awaiting approval section to verify the details of "+ userDetails.firstName + " " + userDetails.lastName)
    }
    const successCallback = (data) => {
      setShowEdit(false);
      setUpdateLoggedinData(prev => !prev);
      console.log(data); 
    }
    const errorCallback = (data) => {
        console.log(data);
    }
    makeApiCallFunc(
        raiseNotificationApi, 
        notificationObj, 
        successCallback,
        errorCallback
        )
  }
  const handleFocus = (e) => 
  {
    setApiError("");
  }

  const legalTypeOnChange = (e) => {
    handleChange(e);
    if(e.target.value === LICENSED)
    {
      setShowMoreLabel(false);
    }
    else
    {
      setShowMoreLabel(true)
    }
  }
   const [apiError, setApiError] = useState("");
   const [profilePic, setProfilePic] = useState(userDetails?.profilePic);
   const [casePref, setCasePref] = useState(userDetails?.casePref ? userDetails?.casePref : null);
   const [statePref, setStatePref] = useState(userDetails?.statePref ? userDetails?.statePref :null);

   const initialValue = {
    email: userDetails?.email ? userDetails?.email : "",
    firstName :userDetails?.firstName ? userDetails?.firstName : "",
    lastName :userDetails?.lastName ? userDetails?.lastName : "",
    company :userDetails?.company ? userDetails?.company : "",
    phoneNumber :userDetails?.phoneNumber ? userDetails?.phoneNumber : "",
    experience :userDetails?.experience ? userDetails?.experience : "",
    legalType :userDetails?.legalType? userDetails?.legalType: "",
    linkedin: userDetails?.linkedin ? userDetails?.linkedin : "",
    lawFirmLink: userDetails?.lawFirmLink ? userDetails?.lawFirmLink : "",
    casePref :  userDetails?.casePref ? userDetails?.casePref : "",
    statePref : userDetails?.statePref ? userDetails?.statePref : "",
}
   const {values, errors, touched, handleBlur, setFieldValue,handleChange, handleSubmit, isSubmitting, submitCount} = useFormik({
      enableReinitialize: true,
      initialValues : initialValue,
      validationSchema : professionalInfoSchema,
      onSubmit,
  })
    useEffect(() => {
      
    console.log("errors changed", (Object.keys(errors).length > 0 && submitCount > 0) || !Object.values(errorMsg).every(msg => msg === "" || msg === null));
    setShowErrorTopMsg((Object.keys(errors).length > 0 && submitCount > 0) || !Object.values(errorMsg).every(msg => msg === "" || msg === null));
  },[errors, errorMsg])
  
  
  return (
    <div className={' w-full bg-white mb-10 ' + (showErrorTopMsg ? ' mt-0 ' : ' mt-10 ') }>
       {console.log("errors", errors)}
       {console.log("touched", touched)}
       {console.log("errorMsg", errorMsg)}
      
      {
        showErrorTopMsg &&
        <FormErrorBanner>Please fix the errors highlighted below to proceed</FormErrorBanner>
      }
    
     <div className='w-full flex grid items-center gap-3 grid-cols-3 lg:grid-cols-6'>
        <div className='flex w-full bg-gray-50 justify-center col-span-3'>
          <div className='w-full'>
          <ProfilePicture setProfilePic={setProfilePic} errorMsg={errorMsg} setErrorMsg={setErrorMsg} profilePic={profilePic}
          />
          </div>
      </div>
      <div className='w-full col-span-3 '>
      <div className='flex w-full flex-col lg:flex-row  ' >
        
        <div className='w-full'>
          <InputElement
              handleChange={(e) =>setFieldValue("firstName", capitalize(e.target.value))}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              label = "First name"
              name = "firstName"
              placeholder= "First name (Required)"
              value = {values.firstName}
              labelError={errors.firstName}
              labelTouched={touched.firstName}
          />
        </div>
        <div className='w-full lg:ml-2'>
          <InputElement 
                handleChange={(e) => setFieldValue("lastName", capitalize(e.target.value))}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Last name"
                name = "lastName"
                placeholder= "Last name (Required)"
                value = {values.lastName}
                labelError={errors.lastName}
                labelTouched={touched.lastName}
            />
        </div>
      </div>
      <div className='flex'>
        {/* <div className='w-full mr-2'>
          <InputElement 
                handleChange={handleChange}
                handleBlur={(e) => {handleBlur(e); checkIfEmailAvailable(e.target.value)}}
                handleFocus={handleFocus}
                label = "Email"
                name = "email"
                disabled = "true"
                placeholder= "Your work email (Required)"
                value = {values.email}
                labelError={errors.email}
                labelTouched={touched.email}
              />
        </div> */}
        <div className=' w-full'>
           <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Phone Number"
                name = "phoneNumber"
                placeholder= "(123)-456-7890 (Optional)"
                value = {values.phoneNumber}
                labelError={errors.phoneNumber}
                labelTouched={touched.phoneNumber}
              />
            
        </div>
      </div>
      </div>
      </div>
      <div className='w-full border-t-[1px] border-t-gray-200 mb-10 pt-6'>
        {/* <div className='w-full font-medium mb-4'>Work details</div> */}
        {values.legalType !== LICENSED &&
            <div className='w-full h-full '>
            <label className="block mt-2 ml-1 text-sm font-medium leading-6 text-gray-900">
            Legal role
            </label>
            <div className="relative mt-2 shadow-sm w-full h-full ">
              <select id="legalType" 
                name = "legalType"
                value={values.legalType}
                onChange={legalTypeOnChange}
                onBlur={handleBlur}
                className=" bg-white h-full w-full   py-1.5 sm:py-2 pl-2 pr-3 text-gray-500  ring-1 ring-inset ring-gray-300 text-xs lg:text-sm focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 ">
                  <option value="">Your designation (Required)</option>
                  <option  value="Paralegal">Paralegal</option>
                  <option value="Legal assistant">Legal assistant</option>
                  <option value="Other">Other</option>
              </select>
            </div>
            {errors.legalType && touched.legalType ? (
                  <FieldError>{errors.legalType}</FieldError>
              ): ""}
            </div>
        }
        <div className='flex items-center  flex-col lg:flex-row mb-2'>
          <div className=' lg:mr-2 w-full'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "What law firm do you work for? (Required)"
                  name = "company"
                  label= "Name of the firm"
                  value = {values.company}
                  labelError={errors.company}
                  labelTouched={touched.company}
                />
          </div>
          <div className='w-full'>
            <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Work experience"
                name = "experience"
                placeholder= "Your total work experience.(Optional)"
                value = {values.experience}
                labelError={errors.experience}
                labelTouched={touched.experience}
              />
          </div>
        </div>
        <div className='flex items-center  flex-col lg:flex-row mb-2'>
          <div className=' lg:mr-2 w-full'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "Law firm link (Required)"
                  name = "lawFirmLink"
                  label= "Law firm link"
                  value = {values.lawFirmLink}
                  labelError={errors.lawFirmLink}
                  labelTouched={touched.lawFirmLink}
                />
          </div>
          <div className='w-full'>
            <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "LinkedIn URL"
                name = "linkedin"
                placeholder= "LinkedIn URL (Optional)"
                value = {values.linkedin}
                labelError={errors.linkedin}
                labelTouched={touched.linkedin}
              />
          </div>
        </div>
       
      </div> 
      
      {
        !showMoreLabel &&
      <div className='w-full border-t-[1px] border-t-gray-200 pt-6'>
        {/* <div className='w-full font-medium mb-2'>Preferences (Required) -
        <span className='font-normal text-gray-800 text-sm ml-2  bg-gray-200'> Select at least one in each Preference category.</span>
        
        </div> */}

        <PreferenceFields states={states}
        casePref={casePref}
        statePref={statePref}
        setCasePref={setCasePref}
        setStatePref={setStatePref}
        setErrorMsg={setErrorMsg}
        errorMsg={errorMsg}
        />
       
        
      </div> 
      }
        <div className={'flex font-medium gap-2 mt-5 ' + (!showBack ? ' justify-center' : '  justify-between')}>
              <div 
                className=
                {"w-full lg:w-1/4  h-10 bg-green-600 hover:bg-green-800 text-white rounded-sm mt-5 flex justify-center items-center cursor-pointer shadow-xl "
                }
                onClick={() => {
                  window.scrollTo(0,0); 
                  //verify the form for profilepic and preferences also
                  if(!profilePic)
                  {
                     setErrorMsg((prev) => { return {...prev, "profilepic" : "Please upload your profile picture"} });
                  }
                  if(casePref?.length === 0 && values.legalType === LICENSED)
                  {
                    setErrorMsg((prev) => { return {...prev, "case" : "Please select atleast one case preference"} });
                  }
                  if(statePref?.length === 0 && values.legalType === LICENSED)
                  {
                    setErrorMsg((prev) => { return {...prev, "state" : "Please select atleast one state preference"} });
                  }
                  handleSubmit()}}>
                  {userDetails.verified ? 
                  "Save updates"
                  :
                 ( showBack ? 
                  "Submit"
                :
                 "Complete Profile ->" 
                )
                  }
                  </div>
              {showBack ? <div 
              className="w-full lg:w-auto px-5 h-10 bg-gray-400 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
              onClick={()=>setShowEdit(false)} >Back</div>
            :
            ''}
        </div>
    </div>
   
  )
}

export default ProfessionalDetailsEdit;
